/**
 * @docType function
 * @ngDoc util
 * @name app.util:URLUtils
 * @author Brian Riley
 * @date July 24, 2014
 * @copyright 2014 Putnam Inc.
 * @description
 *
 *      Simple URL query string utility that's framework independent.
 */
const URLUtil = function () {
    /**
     * Get value of URL param
     * http://url?param1=true&param2=true
     *
     * getURLParam returns true
     * @param {Object} key
     */
    const getURLParam = function (key) {
        const urlParams = getParams();
        if (urlParams) {
            return getParamValue(urlParams, key);
        }

        return null;
    };

    /**
     * Check for params and return set of params for an url
     */
    var getParams = function () {
        let queryString = "";
        // The first part will work when not in a ui-routed state
        // The second part will handle when in a ui-routed state
        if (window.location.search !== "") {
            queryString = window.location.search.substring(1);
        } else {
            // hash will contain the # and anything past it
            queryString = window.location.hash.substring(window.location.hash.indexOf("?") + 1);
        }

        if (queryString.length > 0) {
            return queryString;
        }

        return false;
    };

    /**
     * Utility function to get a particular parameter from list of params
     * @param {Object} params
     * @param {Object} key
     */
    var getParamValue = function (params, key) {
        if (params && key) {
            const paramArray = params.split("&");
            for (let i = 0; i < paramArray.length; i++) {
                const param = paramArray[i].split("=");
                if (param[0] === key) {
                    return param[1];
                }
            }
        }
        return null;
    };

    /**
     * Parse through the URL and return queries as an object.
     *
     * @see http://www.abeautifulsite.net/parsing-urls-in-javascript/
     *
     * @param   String  url The URL to parse
     * @returns Object      An Object representation of the query string
     */
    function getSearchableQueries(url) {
        let search, queries, queryStart, queryEnd, queryString, split;

        // Initialize the search object
        search = {};

        // Get the querystring between the first ? and the first #
        queryStart = url.indexOf("?");

        if (queryStart !== -1) {
            queryString = url.substring(queryStart + 1);
            queryEnd = queryString.indexOf("#");

            if (queryEnd !== -1) {
                queryString = queryString.substring(0, queryEnd);
            }

            // Convert the queries to an object
            queries = queryString.split("&");

            for (let i = 0, n = queries.length; i < n; i++) {
                split = queries[i].split("=");
                search[split[0]] = split[1];
            }
        }

        return search;
    }

    const IURLUtils = {
        getURLParam: getURLParam,
        getAllUrlParams: getParams,
        getSearchableQueries: getSearchableQueries
    };

    return IURLUtils;
};

export default URLUtil();
